<a
  class="love-it-tab"
  [ngClass]="{
    'tab-warning': !invalid && warning,
    'tab-invalid': invalid,
  }">
  @if (!invalid && !warning && icon) {
    <love-it-generic-icon [selector]="icon"></love-it-generic-icon>
  }
  @if (!invalid && warning) {
    <love-it-generic-icon selector="alert-triangle"></love-it-generic-icon>
  }
  @if (invalid) {
    <love-it-generic-icon selector="alert-octagon"></love-it-generic-icon>
  }
  {{ label }}
</a>
